import template from './skeleton.html';
import './style.scss';

export default {
  template,
  controllerAs: 'vm',
  transclude: true,
};
